import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { ProductCarouselTabActions } from "@tCentro/Store/CENProductCarouselTabsReducer";
import { AnyAction } from "redux";

type StatusType = {
    value: boolean;
    parentTab: string;
    currentTab?: string;
};

type CustomStrictInputDispatch = (
    action:
        | ProductCarouselTabActions
        | ((dispatch: CustomStrictInputDispatch, getState: () => ApplicationState) => void),
) => ProductCarouselTabActions;

export type CustomHandlerProps<Parameter, Props> = Props & {
    readonly parameter: Readonly<Parameter>;
    dispatch: CustomStrictInputDispatch;
    getState: () => ApplicationState;
};

export type CustomHandler<Parameter = {}, Props = {}> = (
    props: CustomHandlerProps<Parameter, Props>,
) => false | void | Promise<false | void>;

export const DispatchHandlePDPTabDisplay: CustomHandler<StatusType> = props => {
    switch (props.parameter.parentTab) {
        case "components":
            props.dispatch({
                type: "Custom/CarouselTab/ComponentsTabVisible",
                isComponentsTabVisible: props.parameter.value,
            });
            break;
        case "recentlyViewed":
            props.dispatch({
                type: "Custom/CarouselTab/RecentlyViewedTabVisible",
                isRecentlyViewedTabVisible: props.parameter.value,
            });
            break;
        case "relatedProducts":
            props.dispatch({
                type: "Custom/CarouselTab/RelatedProductsTabVisible",
                isRelatedProductsTabVisible: props.parameter.value,
            });
            break;
        case "topSellers":
            props.dispatch({
                type: "Custom/CarouselTab/TopSellerTabVisible",
                isTopSellerTabVisible: props.parameter.value,
            });
            break;
        case "changeTab":
            props.dispatch({
                type: "Custom/CarouselTab/CurrentTab",
                currentTab: props.parameter.currentTab || "",
            });
            break;

        default:
            break;
    }
};

export const chain = [DispatchHandlePDPTabDisplay];

const handlePDPTabDisplay = createHandlerChainRunner(chain, "HandlePDPTabDisplay");
export default handlePDPTabDisplay;
